<div class="modal-header">
    <h4 class="modal-title">The following form field data was saved:</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <ng-container *ngIf="answers">
        <div *ngFor="let a of answers" class="row">
            <div class="col-xs-6 col-md-6 col-lg-6">{{a.token}}</div>
            <div class="col-xs-6 col-md-6 col-lg-6">{{a.answer}}</div>
        </div>
    </ng-container>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>